// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"JB-z","smallCardRow":"KB-z","largeCardRow":"LB-z","productSearchRow":"MB-z","curatedRow":"NB-z"};